import {AfterViewInit, Component, ViewChildren} from '@angular/core';
import {ModalDialogV3} from '../../../../../../shared-modal-dynamic/models/modal-dialog-v3';


@Component({
  selector: 'app-delete-attention-modal',
  templateUrl: './delete-attention-modal.component.html',
  styleUrls: ['./delete-attention-modal.component.scss']
})
export class DeleteAttentionModalComponent extends ModalDialogV3 implements AfterViewInit {

    @ViewChildren('focusedButton') fb;

    // constructor() {
    //     super();
    // }

    onCancelBtnClicked() {
        super.close();
    }

    onConfirmBtnClicked() {
        this.announceModelChanged( {dialogConfirmed: true});
        super.close();
    }

    ngAfterViewInit(): void {
        this.fb.first.nativeElement.focus();
    }
}
